__turbopack_context__.v({
  "multi_livestream__schedule": "_79glvW_multi_livestream__schedule",
  "multi_livestream__schedule__container": "_79glvW_multi_livestream__schedule__container",
  "multi_livestream__schedule__wrapper": "_79glvW_multi_livestream__schedule__wrapper",
});
